import { useCallback, useEffect, useState } from "react";
import { errMsg } from "@/lib/api";
import { cachedGet, offlineComanda, offlineComandas } from "@/lib/mobile";
import { withGeral } from "@/lib/catalog";
import { useMobile } from "@/context/MobileContext";

export function usePoll(fetcher, ms, deps = []) {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const load = useCallback(() => fetcher().then((d) => { setData(d); setError(""); }).catch((e) => setError(errMsg(e))), deps);
  useEffect(() => {
    load();
    if (!ms) return undefined;
    const t = setInterval(load, ms);
    return () => clearInterval(t);
  }, [load, ms]);
  return { data, setData, error, load };
}

export function useOpenComandas(ms = 8000) {
  const { queue } = useMobile();
  const { data, load } = usePoll(() => cachedGet("/comandas?status=open"), ms);
  return { list: data ? [...offlineComandas(queue), ...data] : null, load };
}

export function useComanda(id, ms = 8000) {
  const { resolveId, queue } = useMobile();
  const realId = resolveId(id);
  const [c, setC] = useState(null);
  const [error, setError] = useState("");
  const load = useCallback(async () => {
    if (realId.startsWith("off-")) {
      const e = queue.find((x) => x.type === "create" && x.temp_id === realId);
      setC(e ? offlineComanda(e) : null);
      setError(e ? "" : "Comanda não encontrada");
      return;
    }
    try {
      setC(await cachedGet(`/comandas/${realId}`));
      setError("");
    } catch (e) {
      setError(errMsg(e));
    }
  }, [realId, queue]);
  useEffect(() => {
    load();
    if (!ms) return undefined;
    const t = setInterval(load, ms);
    return () => clearInterval(t);
  }, [load, ms]);
  return { c, setC, load, error, cid: realId };
}

export function useMobileCatalog() {
  const [data, setData] = useState({ products: [], categories: [], ready: false });
  useEffect(() => {
    Promise.all([cachedGet("/products"), cachedGet("/categories")])
      .then(([p, c]) => setData({ ...withGeral(p.filter((x) => x.active && x.available !== false), c), ready: true }))
      .catch(() => setData((d) => ({ ...d, ready: true })));
  }, []);
  return data;
}
